function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import AllhomesMap from '@domain-group/fe-co-allhomes-map';
import { FullscreenIcon } from '@domain-group/fe-co-icon';
import { storageFactory } from '@domain-group/fe-helper';
import LandDetailsOnboardingMobile from './land-details-onboarding-mobile';
import ModalMap from './modal-map';
import * as styles from './static-map.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ONBOARDING_STORAGE_KEY = 'land-details-onboarding-closed';

/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */

var StaticMap = props => {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var isExpandedBefore = useRef(false);
  var closeExpandedMap = () => setIsExpanded(false);
  var storage = useRef(storageFactory({
    name: 'listing',
    driver: storageFactory.LOCALSTORAGE
  }));
  var _useState3 = useState(!storage.current.getItem(ONBOARDING_STORAGE_KEY)),
    _useState4 = _slicedToArray(_useState3, 2),
    onboardingPopup = _useState4[0],
    setOnboardingPopup = _useState4[1];
  var closeOnboardingPopup = () => {
    setOnboardingPopup(false);
    storage.current.setItem(ONBOARDING_STORAGE_KEY, true);
  };
  return ___EmotionJSX("div", {
    className: "allhomes-listing-map__static-map",
    css: styles.container
  }, ___EmotionJSX("div", {
    css: styles.fullScreenIconContainer
  }, ___EmotionJSX(FullscreenIcon, {
    css: styles.fullScreenIcon
  })), ___EmotionJSX("div", {
    css: styles.imageContainer
  }, ___EmotionJSX("img", {
    onClick: () => {
      setIsExpanded(true);
      if (!isExpandedBefore.current) {
        props.onMapFirstInteraction();
      }
      isExpandedBefore.current = true;
      closeOnboardingPopup();
    },
    css: styles.image,
    alt: "Allhomes static map",
    src: props.signedMapUrl
  }), onboardingPopup && props.overlayMapEnabled && ___EmotionJSX(LandDetailsOnboardingMobile, {
    onClose: closeOnboardingPopup,
    onTryOut: () => {
      setIsExpanded(true);
      closeOnboardingPopup();
    }
  })), isExpanded && ___EmotionJSX(ModalMap, _extends({}, props.expandedMapProps, {
    onCloseClick: closeExpandedMap
  }, props)));
};
StaticMap.propTypes = {
  signedMapUrl: PropTypes.string.isRequired,
  expandedMapProps: PropTypes.shape(AllhomesMap.propTypes).isRequired,
  onMapFirstInteraction: PropTypes.func,
  overlayMapEnabled: PropTypes.bool.isRequired
};
StaticMap.defaultProps = {
  onMapFirstInteraction: () => {}
};
export default StaticMap;